import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Root = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: '12px',
  maxHeight: '400px',
  width: '50%',
  padding: theme.spacing(2),
}));
